import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Pencil, Trash2, Plus } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { ProductForm } from './ProductForm';
import { API, imgSrc, gbp, adminHeaders } from '../../lib/shop';

export const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [editing, setEditing] = useState(null); // null | 'new' | product

  const load = () => axios.get(`${API}/shop/admin/products`, { headers: adminHeaders() }).then(r => setProducts(r.data)).catch(() => toast.error('Failed to load products'));
  useEffect(() => { load(); }, []);

  const remove = async (p) => {
    if (!window.confirm(`Delete "${p.name}"? This cannot be undone.`)) return;
    try {
      await axios.delete(`${API}/shop/admin/products/${p.id}`, { headers: adminHeaders() });
      toast.success('Product deleted');
      load();
    } catch { toast.error('Delete failed'); }
  };

  if (editing) {
    return <ProductForm product={editing === 'new' ? null : editing} onSaved={() => { setEditing(null); load(); }} onCancel={() => setEditing(null)} />;
  }

  return (
    <div data-testid="admin-products">
      <div className="flex justify-between items-center mb-4">
        <p className="text-gray-600 text-sm">{products.length} products</p>
        <Button onClick={() => setEditing('new')} className="bg-pink-500 hover:bg-pink-600 text-white" data-testid="admin-add-product"><Plus className="w-4 h-4 mr-1" /> Add product</Button>
      </div>
      <div className="space-y-3">
        {products.map(p => (
          <div key={p.id} className="flex items-center gap-4 bg-white rounded-xl border border-gray-200 p-3" data-testid={`admin-product-${p.slug}`}>
            <img src={imgSrc(p.image_url)} alt="" className="w-16 h-16 rounded-lg object-cover bg-pink-50" />
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-gray-900 truncate">{p.name}</p>
              <p className="text-sm text-gray-500">{p.category} · {gbp(p.price)} · {p.stock === null ? 'Unlimited' : `${p.stock} in stock`}</p>
            </div>
            {!p.active && <Badge variant="outline" className="text-gray-500">Hidden</Badge>}
            <button onClick={() => setEditing(p)} className="p-2 text-gray-500 hover:text-pink-600" aria-label="Edit" data-testid={`admin-edit-${p.slug}`}><Pencil className="w-5 h-5" /></button>
            <button onClick={() => remove(p)} className="p-2 text-gray-500 hover:text-red-600" aria-label="Delete" data-testid={`admin-delete-${p.slug}`}><Trash2 className="w-5 h-5" /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
